import CONSTANTS from "./constants";
import { call, put, takeLatest } from "redux-saga/effects";
import * as SERVICES from "./services";
import { openPullToRefreshAction } from "../../../PullToRefresh/store";
import parseError from "@src/utils/parseError";
import { checkMmServiceEnabledOnCourses } from "@src/utils/liveService/util";

function* getLiveClassDataSaga(data) {
  yield put({
    type: CONSTANTS.LIVECLASSES_VIDEOSDATA_LOADING,
    payload: true,
  });

  try {
    let apiCall
    const mmServiceEnabledOnCourses = checkMmServiceEnabledOnCourses()
    if (mmServiceEnabledOnCourses){
      apiCall = yield call(SERVICES.getLiveClassDataNewService, data?.payload);
    }else{
      apiCall = yield call(SERVICES.getLiveClassDataService, data?.payload);
    }
    const apiRes = apiCall?.data?.data;

    if (data?.payload?.offset === 0) {
      yield put({
        type: CONSTANTS.LIVECLASSES_VIDEOSDATA_SUCCESS,
        payload: apiRes,
      });
    }
    yield put({
      type: CONSTANTS.LIVECLASSES_VIDEOSLIST_SUCCESS,
      payload: {
        list: apiRes?.list,
        offset: data?.payload?.offset,
        totalCount: apiRes?.totalCount,
        currentList: data?.payload?.currentList,
      },
    });

    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
  } catch (err) {
    parseError(err);
  }
}

function* getBeforeDataSaga(data) {
  yield put({
    type: CONSTANTS.LIVECLASSES_BEFOREDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.getBeforeDataService, data?.payload);
    const apiRes = apiCall?.data?.data;

    yield put({
      type: CONSTANTS.LIVECLASSES_BEFOREDATA_SUCCESS,
      payload: apiRes,
    });
  } catch (err) {
    parseError(err);
  }
}

function* getModalDataSaga(data) {
  yield put({
    type: CONSTANTS.LIVECLASSES_MODALDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.getModalDataService, data?.payload);
    const apiRes = apiCall?.data?.data;

    yield put({
      type: CONSTANTS.LIVECLASSES_MODALDATA_SUCCESS,
      payload: apiRes,
    });

    yield put({
      type: CONSTANTS.LIVECLASSES_MODALSTATE_TOGGLE,
      payload: true,
    });
  } catch (err) {
    parseError(err);
  }
}

function* deleteLiveClassDataSaga(data) {
  yield put({
    type: CONSTANTS.LIVECLASSES_DELETEDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.deleteLiveClassService, data?.payload);
    const apiRes = apiCall?.data?.data;

    yield put({
      type: CONSTANTS.LIVECLASSES_DELETEDATA_SUCCESS,
      payload: apiRes,
    });

    yield put({
      type: CONSTANTS.LIVECLASSES_DELETEMODALSTATE_TOGGLE,
      payload: false,
    });
  } catch (err) {
    parseError(err);
  }
}

export default function* actionWatcher() {
  yield takeLatest(CONSTANTS.LIVECLASSES_VIDEOSDATA_GET, getLiveClassDataSaga);
  yield takeLatest(CONSTANTS.LIVECLASSES_BEFOREDATA_GET, getBeforeDataSaga);
  yield takeLatest(CONSTANTS.LIVECLASSES_MODALDATA_GET, getModalDataSaga);
  yield takeLatest(
    CONSTANTS.LIVECLASSES_DELETEDATA_DELETE,
    deleteLiveClassDataSaga
  );
}
